import React from 'react';
import { Button, Menu, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { VideoLibrary } from '@material-ui/icons';

export interface MenuItem {
  text: string;
  onClick: () => void;
}

interface MenuProps {
  title: string;
  menuItems: MenuItem[];
}

const StyledButton = withStyles({
  root: {
    backgroundColor: "#8d7140",
    borderRadius: "0",
    color: '#fff',
    '&:hover': {
      backgroundColor: '#C2B899',
    },
  },
})(Button);

const SimpleMenu = ({ title, menuItems }: MenuProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <StyledButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
        startIcon={<VideoLibrary />}>
        {title}
      </StyledButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuItems.map(link => 
          <MenuItem
            key={link.text}
            onClick={() => {link.onClick(); handleClose();}}>
            {link.text}
          </MenuItem>
        )}
      </Menu>
    </div>
  );
};

export default SimpleMenu;
